import React, { useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { useSelector, useDispatch } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// actions
import { addDelivered } from "../../../store/actions"
import { useEffect } from "react"

const AddDeliveredOn = props => {
  const dispatch = useDispatch()
  document.title = "Add Delivered On"

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      delivery_name: "",
    },
    validationSchema: Yup.object({
        delivery_name: Yup.string().required(
        "Please Enter Place"
      ),
    }),
    onSubmit: values => {
      dispatch(addDelivered(values, props.history))
    },
  })

  const deliveres = useSelector(state => state.deliveredOn)
  const { error } = useSelector(state => ({
    error: state.deliveredOn.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Add Delivered On" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="form"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="delivery">
                            Delivered On
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="text"
                            name="delivery_name"
                            className={
                              validation.touched.delivery_name &&
                              validation.errors.delivery_name
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="delivery"
                            placeholder="Enter Quality Rating"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.delivery_name || ""}
                          />
                          {validation.touched.delivery_name &&
                          validation.errors.delivery_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.delivery_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      {deliveres && deliveres.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Adding ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Add
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default AddDeliveredOn
